<template>
  <div>
    <el-group-title title="物资合同">
      <template slot="groupTitle">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="163px"
          class="ccui-form demo-form-inline ccui-form-detail"
          :inline="true"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目：" prop="projectName">
                <div>{{ form.projectName }}</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="采购方式：" prop="procurementMethod">
                <div>{{ form.procurementMethod }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="采购计划总编号：" prop="procurementPlanCode">
                <div>{{ form.procurementPlanCode }}</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="招标编号：" prop="biddingCode">
                <div>{{ form.biddingCode }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                label="是否浮动合同价格："
                prop="isFloatContractPrice"
              >
                <div>
                  {{ form.isFloatContractPrice | isFloatContractPrice }}
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="浮动说明：" prop="floatDesc">
                <div>{{ form.floatDesc }}</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="引用招标结果：" prop="quoteBiddingResult">
                <div>{{ form.quoteBiddingResult }}</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="引用招标结果2：" prop="quoteBiddingResult2">
                <div>{{ form.quoteBiddingResult2 }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
export default {
  name: "contractMaterials",
  props: {
    dataInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        id: "",
        projectName: "",
        procurementMethod: "",
        procurementPlanCode: "",
        biddingCode: "",
        isFloatContractPrice: "",
        floatDesc: "",
        quoteBiddingResult: "",
        quoteBiddingResult2: "",
        tContractId: ""
      },
      rules: {}
    };
  },
  filters: {
    isFloatContractPrice(value) {
      const isFloatContractPrice = {
        1: "否",
        2: "是"
      };
      return isFloatContractPrice[value];
    }
  },
  watch: {
    dataInfo() {
      this.form = this.dataInfo;
    }
  }
};
</script>
